import Repository from '@/repositories/RepositoryFactory';
import ENUM from '../../enums/APISTATE';
import Vue from 'vue';

const allocations = Repository.get('allocations');

export default ({
  namespaced: true,
  state: {
    allocationsDashboard: [],
    allocations: [],
    allocation: {},    
    apiState: ENUM.INIT,
    allocationApiState: ENUM.INIT,
    allocationDashboardApiState: ENUM.INIT,
    allocationsTimeOffApiState: ENUM.INIT,
    allocationsTimeOff: [],
    allocationsOnDateApiState: ENUM.INIT,
    allocationsOnDate: []
  },
  mutations: {
    initialized(state, { allocations, allocationsDashboard }) {
      state.allocations = allocations;
      state.allocationsDashboard = allocationsDashboard;
    },
    setApiState: (state, apiState) => {
      state.apiState = apiState;
    },
    setDashboardApiState: (state, apiState) => {
      state.allocationDashboardApiState = apiState;
    },
    setAllocationApiState: (state, apiState) => {
      state.allocationApiState = apiState;
    },
    setAllocation(state, response) {
      const { data } = response;
      state.allocation = data;
      state.allocationApiState = ENUM.LOADED;
    },
    setAllocations(state, response) {
      const { data } = response;
      state.allocations = data;
      state.apiState = ENUM.LOADED;
    },
    setAllocationDashboard(state, response) {
      const { data } = response;
      state.allocationsDashboard = data;
      state.allocationDashboardApiState = ENUM.LOADED;
    },
    setTimeOffApiState: (state, apiState) => {
      state.allocationsTimeOffApiState = apiState;
    },
    setAllocationsTimeOff(state, response) {
      const { data } = response;
      state.allocationsTimeOff = data;
      state.allocationsTimeOffApiState = ENUM.LOADED;
    },
    setAllocationsOnDateApiState: (state, apiState) => {
      state.allocationsOnDateApiState = apiState;
    },
    setAllocationsOnDate(state, response) {
      const { data } = response;
      state.allocationsOnDate = data;
      state.allocationsOnDateApiState = ENUM.LOADED;
    },
    addAllocations(state, response) {
      const { data } = response;
      for(const item of data) {
        state.allocations.push(item);
      }      
      state.apiState = ENUM.LOADED;
    },
  },
  actions: {
    initialize({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          commit('initialized', {
            allocations: allocations
          });
          resolve();
        }
        catch (e) {
          console.error(e);
          reject();
        }
      });
    },
    async getMyAllocations({ commit }, dto) {
      commit('setApiState', ENUM.LOADING);
      try {
        const response = await allocations.getMyAllocations(dto.startDate, dto.endDate, dto.asEmployee);
        if(dto.isLoadingMore) {
          commit('addAllocations', response);          
        } else {
          commit('setAllocations', response);
        }        
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async getTimeOff({ commit }, dto) {
      commit('setTimeOffApiState', ENUM.LOADING);
      try {
        commit('setAllocationsTimeOff', await allocations.getTimeOff(dto.fromDate, dto.forGroup));
      }
      catch (error) {
        console.error(error);
        commit('setTimeOffApiState', ENUM.ERROR);
      }
    },
    async getAllocationDashboard({ commit }, dto) {
      const region = dto ? dto.region : null;
      commit('setDashboardApiState', ENUM.LOADING);
      try {
        commit('setAllocationDashboard', await allocations.getAllocationDashboard(region));
      }
      catch (error) {
        console.error(error);
        commit('setDashboardApiState', ENUM.ERROR);
      }
    },
    async updateAllocation({ commit, dispatch, state }, dto) {
      commit('setAllocationApiState', ENUM.LOADING);
      try {
        const result = await allocations.update(dto);        
        commit('setAllocation', result);
      }
      catch (error) {
        console.error(error);
        commit('setAllocationApiState', ENUM.ERROR);
      }
    },
    // Get's allocation for my calendar for at given date and group
    async getAllocationForGroupOnDate({ commit, dispatch, state }, dto) {
      commit('setAllocationsOnDateApiState', ENUM.LOADING);
      try {
        commit('setAllocationsOnDate', { data: []});
        commit('setAllocationsOnDate', await allocations.getAllocationForGroupOnDate(dto.date, dto.forGroup, dto.asEmployee));
      }
      catch (error) {
        console.error(error);
        commit('setAllocationsOnDateApiState', ENUM.ERROR);
      }
    },
    async splitAllocation({ commit, dispatch, state }, dto) {
      commit('setApiState', ENUM.LOADING);
      try {
        const result = await allocations.split(dto);        
        // TODO: Find a way to add to currect state           
        commit('setApiState', ENUM.LOADED);
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    setAllocations({state}, data) {
      state.allocations = data;
      state.apiState = ENUM.LOADED;
    },
  },
  getters: {
    isLoaded(state) {
      return state.apiState === ENUM.LOADED;
    },
    allocationsApiState(state) {
      return state.apiState;
    },
    allocationApiState(state) {
      return state.allocationApiState;
    },
    allocation(state) {
      return state.allocation;
    },
    allocations(state) { 
      return state.allocations; 
    },
    allocationDashboardApiState(state) {
      return state.allocationDashboardApiState;
    },
    allocationsDashboard(state) { 
      return state.allocationsDashboard; 
    },
    allocationsTimeOffApiState(state) {
      return state.allocationsTimeOffApiState;
    },
    allocationsTimeOff(state) { 
      return state.allocationsTimeOff; 
    },
    allocationsOnDateApiState(state) {
      return state.allocationsOnDateApiState;
    },
    allocationsOnDate(state) {
      return state.allocationsOnDate;
    },
  }
});
